import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerDownLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerDownLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M19.8107 4V14.5H5.87132L9.12132 11.25L8.06066 10.1893L3 15.25L8.06066 20.3107L9.12132 19.25L5.87132 16H21.3107V4H19.8107Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerDownLeft;
